var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-form",
        {
          ref: "navigation-metadata-form",
          staticStyle: { width: "100%" },
          model: {
            value: _vm.formIsValid,
            callback: function ($$v) {
              _vm.formIsValid = $$v
            },
            expression: "formIsValid",
          },
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      box: "",
                      label: "Field Name",
                      rules: _vm.fieldNameRules,
                    },
                    model: {
                      value: _vm.fieldName,
                      callback: function ($$v) {
                        _vm.fieldName = $$v
                      },
                      expression: "fieldName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      box: "",
                      label: "Field Type",
                      items: _vm.fieldTypeNames,
                    },
                    model: {
                      value: _vm.fieldType,
                      callback: function ($$v) {
                        _vm.fieldType = $$v
                      },
                      expression: "fieldType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  !_vm.isTimeField
                    ? _c("metadata-input-field", {
                        attrs: { box: "", "input-type": _vm.fieldType },
                        model: {
                          value: _vm.fieldValue,
                          callback: function ($$v) {
                            _vm.fieldValue = $$v
                          },
                          expression: "fieldValue",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isTimeField
                    ? _c("DateRange", {
                        staticClass: "mb-3",
                        attrs: {
                          rules: {
                            start: [_vm.rules.exists],
                            end: [_vm.rules.exists],
                          },
                          box: "",
                          "no-arrows": "",
                          minDate: _vm.minDateBound,
                          maxDate: _vm.maxDateBound,
                        },
                        model: {
                          value: _vm.dates,
                          callback: function ($$v) {
                            _vm.dates = $$v
                          },
                          expression: "dates",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: {
                        color: "info",
                        block: "",
                        disabled: !_vm.formIsValid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Add")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }